export default __webpack_public_path__ + "static/media/fureverhomes6.271c11fd.png";